import React from 'react';
import GpyComponent from './GpyComponent'
import $ from "jquery";
import FileDrop from 'react-file-drop';
import {_GPY} from '../../../env.js'
import I18nString from '../../../I18nString.js'

class GpyFileUpload extends GpyComponent {


  constructor(props) {
      super(props);
      this.state = {
          fileName: _GPY.i18n.get('component_gpy_file_upload_choosefile_default_text'),
          file: undefined,
          imageSrc : "",
          percentComplete:0,
      };
      // aspectRatio="1" type="jpg,png"
    }

    uploadDone(fileName) {

      if(this.props.callBack !== undefined) {
        this.props.callBack(fileName);
      }
      this.hide();
      this.cleanUp();
    }

    cleanUp() {
      this.setState({fileName: _GPY.i18n.get('component_gpy_file_upload_choosefile_default_text'),
          file: undefined,
          percentComplete:0,
      });
    }


    upload(){
      console.log(this.state.file);
      if(this.state.file !== undefined){

          var data = new FormData();
          data.append('file', this.state.file);
          //data.append('FileName', this.state.file.name);
          var self = this;
          $.ajax({
            xhr: function() {
                var xhr = new window.XMLHttpRequest();
                //Upload progress
                xhr.upload.addEventListener("progress", function(evt){
                  if (evt.lengthComputable) {
                    var percentComplete = Math.floor((evt.loaded / evt.total) * 100);
                    self.setState({percentComplete:percentComplete});
                    console.log(percentComplete);
                  }
                }, false);
                //Download progress
                /*
                xhr.addEventListener("progress", function(evt){
                  if (evt.lengthComputable) {
                    var percentComplete = evt.loaded / evt.total;
                    //Do something with download progress
                    console.log(percentComplete);
                  }
                }, false);
                */
                return xhr;
              },

              method: "POST",
              url: _GPY.baseUrl + 'uploadFile' + _GPY.session,
              data: data,
              dataType: 'json',
              cache: false,
              processData: false,
              contentType: false,
          }).done((data) => {
              console.log(data);
              self.uploadDone(data.Result.resultData);
          }).fail((err) => {
            //  console.log("errorrr for file upload", err);
              //reject(err);
          });
   }
 }



  handleImageFile(f){
    this.setState({fileName:f.name,file:f});

    var reader = new FileReader();
    reader.onload =  (e) => {
        console.log("onload",e);
        this.setState({
            imageSrc:e.target.result,
       });
    };
    reader.readAsDataURL(f);
  }



  handleDrop = (files, event) => {
     var f = files[0];
     this.handleImageFile(f);
  }

  fileChangedHandler(e){
    		e.preventDefault();
        var f = e.target.files[0];
        this.handleImageFile(f);
  }

  show(){
      $(this.modal).modal('show');
  }

  hide(){
      $(this.modal).modal('hide');
  }


  render () {
   var self = this;
   var color = function() {
     // this.state.percentComplete>50?'success':'warning'}
     if(self.state.percentComplete<25) {
       return "progress-bar progress-bar-striped bg-danger progress-bar-animated";
     }
     if(self.state.percentComplete<50) {
       return "progress-bar progress-bar-striped bg-warning progress-bar-animated";
     }
     if(self.state.percentComplete>99) {
       return "progress-bar progress-bar-striped bg-success";
     }
     if(self.state.percentComplete>50) {
       return "progress-bar progress-bar-striped bg-success progress-bar-animated";
     }
   }
   return (
              <span>
              <button type="button" onClick={this.show.bind(this)} className={this.props.className}><span className="glyphicon glyphicon-cloud-upload"/> {this.props.title!==undefined?this.props.title:_GPY.i18n.get('component_gpy_file_upload_button_upload_title')}</button>

              <div className="modal fade" ref={modal=> this.modal = modal} tabIndex="-1" role="dialog" aria-labelledby="gpyModalLabel" aria-hidden="true">
                  <div className="modal-dialog" role="document">
                      <div className="modal-content">
                                  <div className="modal-header">
                                    <I18nString prefix="component_gpy_file_upload"/>
                                    <h5 className="modal-title">{_GPY.i18n.get('component_gpy_file_upload_modal_title')}</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                  </div>
                                  <div className="modal-body">

                                    <div id="react-file-drop-demo">
                                    <FileDrop onDrop={this.handleDrop}>
                                        <div  className="card w-100 p-1 text-center m-auto" style={{height:"100px"}}>
                                            <h5 className="text-muted">{_GPY.i18n.get('component_gpy_file_upload_dropzone_text_prefix')} {this.props.fileTypes!==undefined?this.props.fileTypes:"some"} {_GPY.i18n.get('component_gpy_file_upload_dropzone_text_suffix')}</h5>
                                       </div>
                                     </FileDrop>
                                    </div>
                                    <div className="custom-file mt-2">
                                      <input id="logo" onChange={this.fileChangedHandler.bind(this)} type="file" className="custom-file-input"/>
                                      <label htmlFor="logo" className="custom-file-label">{this.state.fileName}</label>
                                    </div>

                                    {this.state.file !== undefined?
                                    <div className="progress mt-2">
                                      <div className={color()} role="progressbar" style={{width: this.state.percentComplete+"%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    :""}

                                    {this.state.file !== undefined?
                                    <div className="mt-2 text-center" style={{ backgroundRepeat: "repeat", backgroundImage: 'url("'+_GPY.resource("images/transbg.jpg")+'")'}}>
                                      <img style={{maxWidth : '100%', maxHeight : '400px'}} src={this.state.imageSrc} className="img-fluid p-2" alt="UploadImage"/>
                                    </div>
                                    :""}
                                  </div>

                                  <div className="modal-footer">
                                    <button type="button"  onClick={this.hide.bind(this)} className="btn btn-secondary" data-dismiss="modal">{_GPY.i18n.get('component_gpy_file_upload_button_close_title')}</button>
                                    <button type="button" onClick={this.upload.bind(this)} className="btn btn-primary">{_GPY.i18n.get('component_gpy_file_upload_button_upload_title')}</button>
                                 </div>

                       </div>
                 </div>
             </div>
             </span>
           );
    }

}
export default GpyFileUpload;
